import { ReactElement } from 'react';
import { Stack, Box, DialogBody, DialogClose, DialogFooter, DialogHeader } from '@ff-it/ui';
import { Form, Submit, useSubmitHandler } from '@ff-it/form';
import type { ApplicationResponse, AppliedLink } from 'modules/applicator/types';
import { InvoiceWidget } from 'modules/invoicing/common/InvoiceWidget';

type RemoveFormProps = {
  url: string;
  onSubmit: (data: ApplicationResponse) => void;
  applied: AppliedLink;
};

export function RemoveForm({
  url,
  applied: { id, destination, amount },
  onSubmit: onSuccess,
}: RemoveFormProps): ReactElement {
  const submitHandler = useSubmitHandler({ url, method: 'DELETE' }, { onSuccess });

  return (
    <Form initialValues={{ id }} onSubmit={submitHandler}>
      <DialogHeader title="Remove invoice" />
      <DialogBody>
        <Stack direction="horizontal" px="1">
          <Box width="full">
            <InvoiceWidget invoice={destination} />
          </Box>
          <Box width="full">
            <div className="form-control text-right form-control-plaintext font-weight-bold">{amount}</div>
          </Box>
        </Stack>
      </DialogBody>
      <DialogFooter>
        <DialogClose />
        <Submit ml="auto" variant="danger">
          Remove
        </Submit>
      </DialogFooter>
    </Form>
  );
}
